import React from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Chip,
} from '@mui/material';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';

interface SuspensionLogsTableProps {
  logs: any[];
}

const SuspensionLogsTable: React.FC<SuspensionLogsTableProps> = ({ logs }) => {
  const { t } = useTranslation();

  return (
    <TableContainer sx={{ overflowX: 'auto' }}>
      <Table sx={{ minWidth: 650 }}>
        <TableHead>
          <TableRow>
            <TableCell sx={{ minWidth: 120 }}>{t('logistics.preferredDate')}</TableCell>
            <TableCell sx={{ minWidth: 150 }}>{t('admin.user')}</TableCell>
            <TableCell sx={{ minWidth: 100 }}>{t('common.actions')}</TableCell>
            <TableCell sx={{ display: { xs: 'none', sm: 'table-cell' }, minWidth: 200 }}>{t('admin.reasonForSuspension')}</TableCell>
            <TableCell sx={{ display: { xs: 'none', md: 'table-cell' }, minWidth: 150 }}>{t('auth.admin')}</TableCell>
            <TableCell sx={{ minWidth: 120 }}>{t('admin.suspensionDuration')}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {logs.map((log) => (
            <TableRow key={log.id}>
              <TableCell>
                {format(new Date(log.created_at), 'MMM dd, yyyy HH:mm')}
              </TableCell>
              <TableCell>{log.user?.full_name || log.user_id}</TableCell>
              <TableCell>
                <Chip 
                  label={log.action} 
                  size="small"
                  color={log.action.includes('suspend') ? 'warning' : 'default'}
                />
              </TableCell>
              <TableCell sx={{ display: { xs: 'none', sm: 'table-cell' } }}>{log.reason}</TableCell>
              <TableCell sx={{ display: { xs: 'none', md: 'table-cell' } }}>{log.admin?.full_name || log.admin_id}</TableCell>
              <TableCell>
                {log.suspended_until 
                  ? format(new Date(log.suspended_until), 'MMM dd, yyyy')
                  : '-'}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default SuspensionLogsTable;